import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import styles from './style.module.scss';
import VendorRegister from './vendorRegister';
import LeftSection from './component/leftSection';
import EnquiryForm from './component/enquiry/enquiryForm';
import ConfirmationModal from './component/confirmationModal';
import { isMobile } from '../../utils/utils.js';

const Register = () => {
  const [activeStep, setActivestep] = useState('step1');

  return (
    <div>
      <Container fluid>
        <Row className="d-block">
          <LeftSection />
          <Col className={styles.registerContentWrap} md={7}>
            {activeStep === 'step1' ? (
              <div className={isMobile() ? 'w-120' : 'w-100 px-4 py-3'}>
                <div className="text-center">
                  <h2 className="font-weight-bold">Become a Seller on Arzooo</h2>
                  <h5>Share your details here</h5>
                </div>
                <div className={isMobile() ? styles.enquiryFormMobile : styles.enquiryForm}>
                  <EnquiryForm setActivestep={setActivestep} />
                </div>
              </div>
            ) : (
              <VendorRegister />
            )}
          </Col>
        </Row>
        <ConfirmationModal />
      </Container>
    </div>
  );
};

export default Register;
